import { useCallback, useEffect, useRef, useState } from 'react';

import { getCoursesFeaturesConfig } from '../../../../api/requests/settings';
import { CoursesFeaturesOptions } from '../interfaces/courses-features.interface';

export const useCoursesFeaturesConfig = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const alreadyFetched = useRef(false);

  const [config, setConfig] = useState<CoursesFeaturesOptions | null>();
  const [error, setError] = useState(false);

  const fetchConfig = useCallback(async () => {
    if (alreadyFetched.current) setIsRefetching(true);
    else alreadyFetched.current = true;

    const { data, error: fetchError } = await getCoursesFeaturesConfig();

    if (fetchError) {
      setError(true);
    } else {
      setConfig(data);
    }

    setIsLoading(false);
    setIsRefetching(false);
  }, [alreadyFetched]);

  useEffect(() => {
    if (!alreadyFetched.current) {
      fetchConfig();
    }
  }, [fetchConfig]);

  return {
    isLoading,
    config,
    error,
    refetch: fetchConfig,
    isRefetching,
  };
};
